// extracted by css-extract-rspack-plugin
export default {"button":"ColumnInput-module__button___EaMId","root":"ColumnInput-module__root___aBMiW","open":"ColumnInput-module__open___xw3cu"};